
import Link21 from "../../../assets/duotone/Link21.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Link21Icon({ className, dataTestid = "Link21Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Link21 data-testid={dataTestid} className={classes} {...rest} />
  );
}
